var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"offer-slider"},[_c('DefaultOfferSlider',{attrs:{"slides":_vm.filteredSlidesData,"additional-settings":_vm.additionalSettings},scopedSlots:_vm._u([{key:"slide",fn:function({slide}){return [_c('SlideItem',_vm._b({},'SlideItem',slide,false))]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }